export default __webpack_public_path__ + "static/media/bg-pes-1.fe58b25a.png";